module.exports = __webpack_public_path__ + "img/ics_f_announce_red.267a85d9.svg";